<div class="grid">
  <label class="lg:col-2 col-12 md:col-4 control-label">{{ 'PRODUCTOACTIVIDAD.LBL_SEGMENTO' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{proActividad.nombreSegmento}}</strong></label>
</div>

<div class="grid">
  <div class="col-12 md:col-10 md:col-offset-1">
    <p-fieldset legend="{{ 'PRODUCTOACTIVIDAD.LBL_CAMPOSFORMULARIO' | translate }}">
      <div *ngFor="let campo of lisProductoActividadCampo; let i=index">
        <div class="grid" *ngIf="i%3===0">
          <ng-container *ngFor="let iteracion of iterador; let ite=index">
            <div class="col-4 md:col-4 lg:col-4" *ngIf="lisProductoActividadCampo.length > (i + ite)">
              <p-checkbox label="{{ lisProductoActividadCampo[i + ite].nombreCampo }}" binary="true"
                          [(ngModel)]="lisProductoActividadCampo[i + ite].indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </div>
          </ng-container>
        </div>
      </div>
    </p-fieldset>
  </div>
</div>

<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
            pButton (click)="regresar()"></button>
  </div>
</div>
